import React from 'react';
import { useCart } from '../context/CartContext';
import CartDrawer from './CartDrawer';

// This component renders the cart modal at the app level
// to ensure only one modal is ever rendered
const CartModalPortal = () => {
  const { isCartOpen } = useCart();
  
  // Only render if cart is open
  if (!isCartOpen) return null;
  
  // Render the CartDrawer in modal mode
  return <CartDrawer modalOnly />;
};

export default CartModalPortal;
